import React from 'react';
import { Box } from '@mui/material';
import { TallyCompany } from '../../../../../types/tally';
import EditGstActions from './EditGstActions';
import PresentActions from './PresentActions';
import DefaultActions from './DefaultActions';

interface CompanyActionsProps {
  company: TallyCompany;
  onFetchDetails: (company: TallyCompany) => void;
  onAddCompany: (company: TallyCompany) => void;
  onEditGst: (companyName: string) => void;
  onSaveGst: (companyName: string) => void;
  onCancelEditGst: (companyName: string) => void;
  onFetchVendorDetails: (companyName: string) => void;
  onDownloadCorruptedVendors: (companyName: string) => void;
}

import CorruptedVendorsActions from './CorruptedVendorsActions';

const CompanyActions: React.FC<CompanyActionsProps> = props => {
  const { company, onSaveGst, onCancelEditGst, onFetchVendorDetails, onDownloadCorruptedVendors, ...rest } =
    props;

  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
      {company.corruptedVendors && company.corruptedVendors.length > 0 && (
        <CorruptedVendorsActions
          companyName={company.name}
          onDownloadCorruptedVendors={onDownloadCorruptedVendors}
        />
      )}
      {company.isEditingGst ? (
        <EditGstActions
          onSaveGst={onSaveGst}
          onCancelEditGst={onCancelEditGst}
          companyName={company.name}
        />
      ) : company.dbStatus === 'present' ? (
        <PresentActions
          onFetchVendorDetails={() => onFetchVendorDetails(company.name)}
          companyName={company.name}
        />
      ) : (
        <DefaultActions company={company} {...rest} />
      )}
    </Box>
  );
};

export default CompanyActions;
